class Common {
    constructor() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    channelActive(channel) {
        TVSite.channelVideosData = channel;
        TVSite.isChannelPage = true;
        TVSite.isHomePage = false;
        TVSite.isPlaybackPage = false;
        TVSite.isVideoPage = false;
        TVSite.isSearchPage = false;
    }

    channelVideoActive(video) {
        TVSite.channelVideosData.video = video;
        TVSite.isPlayerPage = true;
        TVSite.isHomePage = false;
        TVSite.isChannelPage = false;
        TVSite.isVideoPage = false;
        TVSite.isSearchPage = false;
    }

    searchActive() {
        TVSite.isSearchPage = true;
        TVSite.isHomePage = false;
        TVSite.isPlayerPage = false;
        TVSite.isVideoPage = false;
        TVSite.isChannelPage = false;
    }

    videoActive() {
        TVSite.isVideoPage = true;
        TVSite.isHomePage = false;
        TVSite.isPlayerPage = false;
        TVSite.isSearchPage = false;
        TVSite.isChannelPage = false;
    }

    homeActive() {
        TVSite.isHomePage = true;
        TVSite.isPlayerPage = false;
        TVSite.isVideoPage = false;
        TVSite.isSearchPage = false;
        TVSite.isChannelPage = false;
    }

    getPostedDate(unixStamp) {
        var today = new Date();
        var justPosted = false;
        var d = (new Date(Number(unixStamp) * 1000));
        var singleOrPlus = function(Type, value) {
            return value + (value > 1 ? (" " + Type + "s") : (" " + Type)) + " ";
        }

        function getDaysInMonth(month, year) {
            if (typeof year == "undefined") year = 1999;
            var currmon = new Date(year, month),
                nextmon = new Date(year, month + 1);
            return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
        }

        function getDateTimeSince(target) {
            var now = new Date(), yd, md, dd, hd, nd, sd, out = [];

            yd = now.getFullYear() - target.getFullYear();
            md = now.getMonth() - target.getMonth();
            dd = now.getDate() - target.getDate();
            hd = now.getHours() - target.getHours();
            nd = now.getMinutes() - target.getMinutes();
            sd = now.getSeconds() - target.getSeconds();

            if (md < 0) {
                yd--;
                md += 12;
            }
            if (dd < 0) {
                md--;
                dd += getDaysInMonth(now.getMonth() - 1, now.getFullYear());
            }
            if (hd < 0) {
                dd--;
                hd += 24;
            }
            if (nd < 0) {
                hd--;
                nd += 60;
            }
            if (sd < 0) {
                nd--;
                sd += 60;
            }

            if (yd > 0) out.push(singleOrPlus("Year", yd));
            if (md > 0 && yd < 1) out.push(singleOrPlus("Month", md));
            if (dd > 0 && md < 1) out.push(singleOrPlus("Day", dd));
            if (hd > 0 && dd < 1) out.push(singleOrPlus("Hour", hd));
            if (!out.length) justPosted = true;
            return out.join(" ");
        }

        var postedDate = getDateTimeSince(d) + "ago";
        if (justPosted)
            postedDate = "Now";
        return postedDate;
    }

    isJson(str) {
        try {
            var myJSON = JSON.stringify(str);
            var json = JSON.parse(myJSON);
            if (typeof(str) == 'string')
                if (str.length == 0)
                    return false;
        }
        catch (e) {
            return false;
        }
        return true;
    }

    getVideoUrl(video) {
        var videoTitle = "titleTextEncoded" in video ? video.titleTextEncoded : video.title.replace(/ /g, "-");
        var formedUrl = TVSite.baseUrl + TVSite.channelVideosData.titleTextEncoded + "/" + videoTitle + "/" + TVSite.channelVideosData.id + "-" + video.id + "/";
        return formedUrl.toLowerCase();
    }

    getVideoPageUrl(video) {
        var videoTitle;
        video.hasOwnProperty("titleTextEncoded") ? videoTitle = video.titleTextEncoded : (video.hasOwnProperty("data") && (video.data = this.isJson(video.data) ? video.data : JSON.parse(video.data)), video.data.hasOwnProperty("titleTextEncoded") && (videoTitle = video.data.titleTextEncoded));
        var formedUrl = TVSite.baseUrl + "v" + "/" + videoTitle.toString() + "/" + video.id + "/";
        return formedUrl.toLowerCase();
    }

    getDateFromUnix(unixDate) {
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var d = (new Date(Number(unixDate) * 1000));
        var month = months[d.getMonth()];
        var day = '' + d.getDate() + ',';
        var year = d.getFullYear();
        return [month, day, year].join(' ');

    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    createProductStructureData(product) {
        let schema = document.createElement("script");
        let data = [];
        const schemaStructure = {
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": product.title,
            "image": product.imageUrl,
            "description": product.description,
            "mpn": product.mpn || null,
            "offers": {
                "@type": "Offer",
                "priceCurrency": "USD",
                "price": product.price === 'Out Of Stock' ? '0.00' : product.price,
                "availability": product.price === 'Out Of Stock' ? "http://schema.org/OutOfStock" : "http://schema.org/InStock"
            }
        };
        data.push(schemaStructure);
        schema.type = "application/ld+json";
        schema.text = JSON.stringify(data);
        document.querySelector("head").appendChild(schema);
    }

    trimPrice(p) {
        var price = p || '';
        price = price.toString().replace(/[^0-9.]+/g, '');
        price = parseFloat(price).toFixed(2);
        price = price > 0 ? ('$' + price) : '';
        return price;
    }

    debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    linkify(html) {
        return html
            .replace(/[^\"]http(.*)\.(png|jpg|jpeg|gif)/g, ' <img src="http$1.$2">'
                .replace(/[^\"]http(.*)\.([a-zA-Z]*)/g, ' <a href="http$1.$2">http$1.$2</a>')
            );
    }
};
export default new Common();
